import dayjs from 'dayjs'
import { projectTypeName } from '../../../common/constants'
import { centsToDollarsDisplay } from '../../displayFormatters'
import { CsvColumn } from '../reportCsvExport'
import { InvoiceReportData } from './invoiceReportApi'

export const paidAmountCents = (invoice: InvoiceReportData): number =>
  invoice.totalInvoicedAmount - invoice.totalInvoiceBalance

// The rows on any of the three tabs, so a job that shows on none of them stays out of the file too.
export const invoiceExportRows = (invoices: InvoiceReportData[]): InvoiceReportData[] =>
  invoices.filter(invoice => invoice.unbilledAmount !== 0 || invoice.invoiceBalance !== 0 || paidAmountCents(invoice) !== 0)

// The same columns and formatting as the Invoicing table, plus a numeric (USD) column per amount.
export const invoiceExportColumns: CsvColumn<InvoiceReportData>[] = [
  {
    title: 'Project Name',
    dataIndex: 'name',
  },
  {
    title: 'Job Type',
    dataIndex: 'jobType',
    render: (_, record) => projectTypeName(record.jobType)
  },
  {
    title: 'Customer',
    dataIndex: 'customerDisplayName',
  },
  {
    title: 'Not Invoiced Total',
    dataIndex: 'unbilledAmount',
    render: (_, record) => `${centsToDollarsDisplay(record.unbilledAmount)}`,
    exportCents: record => record.unbilledAmount
  },
  {
    title: 'Outstanding Total',
    dataIndex: 'invoiceBalance',
    render: (_, record) => `${centsToDollarsDisplay(record.invoiceBalance)}`,
    exportCents: record => record.invoiceBalance
  },
  {
    title: 'Paid Price',
    dataIndex: 'finalPrice',
    render: (_, record) => `${centsToDollarsDisplay(paidAmountCents(record))}`,
    exportCents: paidAmountCents
  },
  {
    title: 'Last Invoice Date',
    dataIndex: 'lastInvoiceDate',
    render: (_, record) => {
      return record.lastInvoiceDate ? `${dayjs(record.lastInvoiceDate).format('MM/DD/YYYY')}` : ''
    }
  }
]
